

// import React from "react";

// function Checkout() {
//   return (
//     <div className="w-full mx-auto my-8 flex justify-center bg-white p-8 border rounded-lg shadow-md items-center">
//       {/* Summary Section */}
//       <div className="w-1/2"></div>

//       {/* Checkout Section - Leave Unchanged */}
//       <div className="w-full">
//         <h2 className="text-xl font-semibold mb-4">CHECKOUT</h2>

//         <div className="space-y-4 text-gray-700">
//           <div className="flex justify-between">
//             <span>Booking Fee</span>
//             <span>₹11753.00</span>
//           </div>
//           <div className="flex justify-between">
//             <span>Extra Helmet</span>
//             <span>₹100.00</span>
//           </div>
//           <div className="flex justify-between">
//             <span>Extra Jacket</span>
//             <span>₹300.00</span>
//           </div>
//           <div className="flex justify-between">
//             <span>CGST (14%)</span>
//             <span>₹1645.42</span>
//           </div>
//           <div className="flex justify-between">
//             <span>SGST (14%)</span>
//             <span>₹1645.42</span>
//           </div>
//         </div>

//         <div className="mt-6 border-t pt-4 flex justify-between text-lg font-semibold">
//           <span>Total Payable Amount</span>
//           <span>₹15043.84</span>
//         </div>

//         <button className="w-full bg-orange-600 text-white py-2 mt-4 rounded">
//           MAKE PAYMENT
//         </button>

//         {/* Additional Info */}
//         <div className="mt-8 text-gray-500">
//           <h3 className="font-semibold">Additional Info</h3>
//           <div className="flex justify-between mt-2">
//             <span>Km limit</span>
//             <span>1288 km</span>
//           </div>
//           <div className="flex justify-between mt-2">
//             <span>Excess km charges</span>
//             <span>₹10.00</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Checkout;



// import React from "react";

// function Checkout() {
//   return (
//     <div className="w-full h-auto mx-auto  p-6 bg-white border rounded-lg shadow-md">
//       {/* Checkout Section */}
//       <div>
//         <h2 className="text-xl font-semibold mb-6">CHECKOUT</h2>

//         <div className="space-y-4 text-gray-700">
//           <div className="flex justify-between">
//             <span>Booking Fee</span>
//             <span>₹ 11753.00</span>
//           </div>
//           <div className="flex justify-between">
//             <span>Extra Helmet</span>
//             <span>₹ 100.00</span>
//           </div>
//           <div className="flex justify-between">
//             <span>Extra Jacket</span>
//             <span>₹ 300.00</span>
//           </div>
//           <div className="flex justify-between">
//             <span>CGST (14%)</span>
//             <span>₹ 1645.42</span>
//           </div>
//           <div className="flex justify-between">
//             <span>SGST (14%)</span>
//             <span>₹ 1645.42</span>
//           </div>
//         </div>

//         {/* Total Amount */}
//         <div className="mt-6 border-t pt-4 flex justify-between text-lg font-semibold">
//           <span>Total Payable Amount</span>
//           <span>₹ 15043.84</span>
//         </div>

//         {/* Payment Button */}
//         <button className="w-full bg-[#FF9630] text-white py-2 mt-4 rounded font-semibold">
//           MAKE PAYMENT
//         </button>
//       </div>

//       {/* Additional Info Section */}
//       <div className="mt-8 pt-4 border-t text-gray-700">
//         <h3 className="text-base font-semibold mb-3">Additional Info</h3>
//         <div className="flex justify-between">
//           <span>
//             Km limit <span className="text-gray-500">(?)</span>
//           </span>
//           <span>1288 km</span>
//         </div>
//         <div className="flex justify-between mt-2">
//           <span>
//             Excess km charges <span className="text-gray-500">(?)</span>
//           </span>
//           <span>₹10.00</span>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Checkout;



import React, { useState } from 'react';
import Terms from '../T&C/Terms';
function Checkout() {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  const handlePaymentClick = () => {
    setIsPaymentModalOpen(true);
  };

  const closePaymentModal = () => {
    setIsPaymentModalOpen(false);
  };

  return (
    <>
      <div className="w-full h-auto mx-auto mt-4 p-6 bg-white border rounded-lg shadow-md">
        {/* Checkout Section */}
        <div>
          <h2 className="text-xl font-semibold mb-6">CHECKOUT</h2>

          <div className="space-y-4 text-gray-700">
            <div className="flex justify-between">
              <span>Booking Fee</span>
              <span>₹ 11753.00</span>
            </div>
            <div className="flex justify-between">
              <span>Extra Helmet</span>
              <span>₹ 100.00</span>
            </div>
            <div className="flex justify-between">
              <span>Extra Jacket</span>
              <span>₹ 300.00</span>
            </div>
            <div className="flex justify-between">
              <span>CGST (14%)</span>
              <span>₹ 1645.42</span>
            </div>
            <div className="flex justify-between">
              <span>SGST (14%)</span>
              <span>₹ 1645.42</span>
            </div>
          </div>

          {/* Total Amount */}
          <div className="mt-6 border-t pt-4 flex justify-between text-lg font-semibold">
            <span>Total Payable Amount</span>
            <span>₹ 15043.84</span>
          </div>

          {/* Payment Button */}
          <button
            className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white font-semibold py-2 rounded mt-4 transition"
            onClick={handlePaymentClick}
          >
            MAKE PAYMENT
          </button>
        </div>
      </div>
      {/* Additional Info Section */}
      <div className="w-full h-auto mx-auto mt-12 p-6 bg-white border rounded-lg shadow-md">
        <div className="  text-gray-700">
          <h3 className="text-base font-semibold mb-3">Additional Info</h3>
          <div className="flex justify-between">
            <span>
              Km limit <span className="text-gray-500">(?)</span>
            </span>
            <span>1288 km</span>
          </div>
          <div className="flex justify-between mt-2">
            <span>
              Excess km charges <span className="text-gray-500">(?)</span>
            </span>
            <span>₹10.00</span>
          </div>
        </div>
        <Terms open={isPaymentModalOpen} Close={closePaymentModal} />
      </div>
    </>
  );
}

export default Checkout;
